import Vue from 'vue';

const storageObject = (function storageObject() {
  class Storage {
    constructor() {
      this.COMPANY_KEY = '';
    }

    SetCompanyKey(userId) {
      if ((userId || '') === '') {
        this.COMPANY_KEY = '';
      } else {
        this.COMPANY_KEY = `TE_STORAGE:${userId}:COMPANY`;
      }
    }

    GetCompany() {
      if ((this.COMPANY_KEY || '') !== '') {
        return localStorage.getItem(this.COMPANY_KEY);
      }
      return '';
    }

    SetCompanyLocalStorage(company) {
      if ((this.COMPANY_KEY || '') !== '') {
        localStorage.setItem(this.COMPANY_KEY, company);
      }
    }

    RemoveCompanyLocalStorage() {
      if ((this.COMPANY_KEY || '') !== '') {
        localStorage.removeItem(this.COMPANY_KEY);
      }
    }

    CreatePlugin() {
      return (store) => {
        store.watch(
          () => store.getters.userId,
          (newValue) => {
            this.SetCompanyKey(newValue);
          }
        );
        store.subscribe((mutation) => {
          switch (mutation.type) {
            case 'setCompany':
              if (mutation.payload) {
                this.SetCompanyLocalStorage(mutation.payload);
              } else {
                this.RemoveCompanyLocalStorage();
              }
              break;
            default:
              break;
          }
        });
      };
    }
  }
  return new Storage();
}());

const companyModule = {
  state: {
    currentCompany: ''
  },
  getters: {
    company: (state) => state.currentCompany || ''
  },
  mutations: {
    setCompany(state, companyId) {
      Vue.set(state, 'currentCompany', companyId || '');
    }
  },
  actions: {
    loadCompany({ commit, getters }) {
      commit('setCompany', storageObject.GetCompany(getters.userId));
    }
  }
};

export default {
  module: companyModule,
  plugin: storageObject.CreatePlugin()
};
